import { NgModule } from '@angular/core';

import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { TabQrCodeComponent } from './tab-qr-code.component';

@NgModule({
  declarations: [
    TabQrCodeComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule
  ],
  exports: [
    TabQrCodeComponent
  ]
})
export class TabQrCodeModule { }
